// extracted by mini-css-extract-plugin
export default {"divBotaoSalvar":"stylesCadastroUsuarios_divBotaoSalvar__uU93K","botaoSalvar":"stylesCadastroUsuarios_botaoSalvar__YIT2B"};